import { createElement } from "react";
export const TEXT_TYPE = {
  default: -1,
  primary: 0,
  secondary: 1,
  error: 2,
  succcess: 3,
  warning: 4,
  link: 5,
  white: 6,
};

const COLOR_MAP = {
  [TEXT_TYPE.default]: "#000000",
  [TEXT_TYPE.primary]: "#31b0d5",
  [TEXT_TYPE.secondary]: "#9e9e9e",
  [TEXT_TYPE.error]: "#f44336",
  [TEXT_TYPE.succcess]: "#4caf50",
  [TEXT_TYPE.warning]: "#ff9800",
  [TEXT_TYPE.link]: "#2196f3",
  [TEXT_TYPE.white]: "#fff",
};

const Element = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "div",
};

function Text(props: any) {
  const {
    size = 3, type = TEXT_TYPE.default, bold, lineHeight, style, ...rest
  } = props;
  const divStyles = size === 6 ? {
    fontSize: "calc(1.6 * #{var(--safari-root-font, 10px)})",
    marginTop: "calc(0.5 * #{var(--safari-root-font, 10px)})",
    marginBottom: "calc(0.5 * #{var(--safari-root-font, 10px)})",
  } : {};
  return createElement(Element[size], {
    style: {
      ...divStyles,
      fontWeight: bold ? "bold" : "normal",
      color: COLOR_MAP[type],
      lineHeight: lineHeight || 1.1,
      ...style,
    },
    ...rest,
  }, props.children);
}

export default Text;
